module.exports = __webpack_public_path__ + "img/logo_black.03aaccb4.png";